// extracted by mini-css-extract-plugin
module.exports = {"tip-box":"OverflowTip_tip-box__VeVhJ","tipBox":"OverflowTip_tip-box__VeVhJ","tp":"OverflowTip_tp__hToKd"};